import styled from 'styled-components';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';
import { ErrorStatePageError } from 'ui/illustrations/ErrorStatePageError';

const StyledPlaceholderState = styled(PlaceholderState)`
  width: 100%;
`;

export const HomepageErrorBoundaryState = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <StyledPlaceholderState
    data-test="homepage-content-error-boundary"
    Illustration={ErrorStatePageError}
    title="We’ve hit a snag"
    {...props}
  >
    Sorry, we’re having trouble loading this content right now. We've logged an error and are
    working to fix it.
  </StyledPlaceholderState>
);
